'use client'
import React, { useEffect, useCallback, useState } from 'react'
import styles from './styles.module.scss'
import { getElementHeight } from '@l2p/apps-shared'

const LoadMoreMask: React.FC<{
  cardClassName?: string
  children: React.ReactNode
}> = ({ cardClassName, children }) => {
  const [dynamicHeight, setDynamicHeight] = useState<string | number>(0)

  const onResize = useCallback(() => {
    setDynamicHeight(getElementHeight(cardClassName || 'game-card-collection'))
  }, [cardClassName])

  useEffect(() => {
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [onResize])

  return (
    <div className={styles.container} style={{ height: dynamicHeight }}>
      {children}
    </div>
  )
}

export default LoadMoreMask
